import { render } from "./AvailablePaymentMessage.vue?vue&type=template&id=deef6892"
import script from "./AvailablePaymentMessage.vue?vue&type=script&lang=js"
export * from "./AvailablePaymentMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__